import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { SphereCircularProgress } from "@components/common/sphere-circular-progress";
import { ThumbnailImage } from "@components/common/thumbnail-image";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Box } from "@mui-wrapper";
import { DeleteIcon, Text, Tooltip } from "@flat-ui";
import { FILE_SIZE_MULTIPLIER } from "@utils/file-utils";
import { useMemo } from "react";
import defaultUploadImage from "/src/assets/illustrations/upload-image.webp";
import { PALETTE_VARS } from "@styles/palette-vars";
/** CSS class name for the remove workspace logo button  */
export const REMOVE_WORKSPACE_LOGO = "removeWorkspaceLogo";

/** Renders the dropzone elements based on the loading state */
export function DropzoneElements(t0) {
  const $ = _c(43);
  const {
    avatar,
    isLoading,
    uploadProgress,
    existingImageUrl,
    setFileInputEl,
    selectFileFromDialog,
    onDeleteButtonClick,
    deleteIconTooltipText,
    shouldShowSupportedFormats: t1,
    shouldShowSizeLimit: t2,
    allowedExtensions,
    instruction: t3,
    maxFileSize,
    shouldAllowMultiUpload,
    shouldAllowFiles: t4
  } = t0;
  const shouldShowSupportedFormats = t1 === undefined ? true : t1;
  const shouldShowSizeLimit = t2 === undefined ? true : t2;
  const instruction = t3 === undefined ? "Drag your image here" : t3;
  const shouldAllowFiles = t4 === undefined ? true : t4;
  const {
    isHoverSupported
  } = useMediaQueryList();
  let t5;
  if ($[0] !== allowedExtensions) {
    t5 = allowedExtensions.map(_temp).join(", ");
    $[0] = allowedExtensions;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const allowedExtensionsList = t5;
  const maxFileSizeToShow = maxFileSize >= FILE_SIZE_MULTIPLIER ? `${maxFileSize / FILE_SIZE_MULTIPLIER} GB` : `${maxFileSize} MB`;
  let t6;
  if (shouldAllowMultiUpload && shouldAllowFiles) {
    t6 = "files";
  } else {
    t6 = shouldAllowFiles === false ? "folder" : "file";
  }
  const entitiesToUploadStr = t6;
  if (isLoading) {
    let t7;
    if ($[2] !== uploadProgress) {
      t7 = <SphereCircularProgress value={uploadProgress} label="Uploading..." />;
      $[2] = uploadProgress;
      $[3] = t7;
    } else {
      t7 = $[3];
    }
    return t7;
  }
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      height: "100px",
      width: "100px"
    };
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== avatar || $[6] !== existingImageUrl) {
    t8 = avatar ? avatar : <ThumbnailImage src={existingImageUrl?.length ? existingImageUrl : undefined} fallbackSrc={defaultUploadImage} sx={{
      maxHeight: "100%",
      maxWidth: "100%"
    }} alt={existingImageUrl?.length ? "Your uploaded image" : "The default image indicates that an image can be uploaded here"} />;
    $[5] = avatar;
    $[6] = existingImageUrl;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t8) {
    t9 = <Box component="div" sx={t7}>{t8}</Box>;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      color: "text.primary",
      fontSize: "14px",
      marginBottom: "7px"
    };
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      textDecoration: "underline",
      color: PALETTE_VARS.primary.main
    };
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== entitiesToUploadStr) {
    t12 = <span style={t11}>select {entitiesToUploadStr}</span>;
    $[12] = entitiesToUploadStr;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== instruction || $[15] !== t12) {
    t13 = <Box component="div" sx={t10} data-testid="dropzone-title">{instruction}, or{" "}{t12}{" "}to upload</Box>;
    $[14] = instruction;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== allowedExtensionsList || $[18] !== shouldShowSupportedFormats) {
    t14 = shouldShowSupportedFormats && <Text variant="bodyM" component="div" sx={{
      color: "text.secondary"
    }} data-testid="dropzone-sub-title">Supported formats {allowedExtensionsList}</Text>;
    $[17] = allowedExtensionsList;
    $[18] = shouldShowSupportedFormats;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== maxFileSizeToShow || $[21] !== shouldShowSizeLimit) {
    t15 = shouldShowSizeLimit && <Text variant="bodyM" component="div" sx={{
      color: "text.secondary"
    }} data-testid="dropzone-sub-title-file-size">Maximum file size: {maxFileSizeToShow}</Text>;
    $[20] = maxFileSizeToShow;
    $[21] = shouldShowSizeLimit;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t13 || $[24] !== t14 || $[25] !== t15) {
    t16 = <Box>{t13}{t14}{t15}</Box>;
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      display: "none"
    };
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== allowedExtensionsList || $[29] !== selectFileFromDialog || $[30] !== setFileInputEl || $[31] !== shouldAllowMultiUpload) {
    t18 = <input ref={setFileInputEl} type="file" style={t17} accept={allowedExtensionsList} onChange={selectFileFromDialog} multiple={shouldAllowMultiUpload} data-testid="dropzone-input" />;
    $[28] = allowedExtensionsList;
    $[29] = selectFileFromDialog;
    $[30] = setFileInputEl;
    $[31] = shouldAllowMultiUpload;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== deleteIconTooltipText || $[34] !== existingImageUrl?.length || $[35] !== isHoverSupported || $[36] !== onDeleteButtonClick) {
    t19 = onDeleteButtonClick && existingImageUrl?.length !== 0 && <Box className={REMOVE_WORKSPACE_LOGO} sx={{
      position: "absolute",
      top: 10,
      right: 10,
      visibility: isHoverSupported ? "hidden" : "visible"
    }}><Tooltip component="div" title={deleteIconTooltipText}><SphereIconButton component={DeleteIcon} onClick={e => {
          e.stopPropagation();
          onDeleteButtonClick();
        }} iconSize="19px" buttonSize="40px" /></Tooltip></Box>;
    $[33] = deleteIconTooltipText;
    $[34] = existingImageUrl?.length;
    $[35] = isHoverSupported;
    $[36] = onDeleteButtonClick;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t16 || $[39] !== t18 || $[40] !== t19 || $[41] !== t9) {
    t20 = <>{t9}{t16}{t18}{t19}</>;
    $[38] = t16;
    $[39] = t18;
    $[40] = t19;
    $[41] = t9;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  return t20;
}
function _temp(extension) {
  return `.${extension}`;
}